import { useRifm } from "rifm";
import { useState } from "react";
const parseDigits = (string: string) => (string.match(/\d+/g) || []).join("");

const phoneFormat = (string: string) => {
  const digits = parseDigits(string);
  const chars = digits.split("");
  return chars
    .reduce(
      (r, v, index) => (index === 3 || index === 6 ? `${r}-${v}` : `${r}${v}`),
      ""
    )
    .substr(0, 12);
};

const addMask = (string: string) => {
  const digits = parseDigits(string);
  const areaCode = digits.slice(0, 3).padEnd(3, "_");
  const prefix = digits.slice(3, 6).padEnd(3, "_");
  const lineNumber = digits.slice(6, 10).padEnd(4, "_");
  return `${areaCode}-${prefix}-${lineNumber}`;
};

type PhoneFieldProps = {
  validateInput: (
    e: React.FormEvent<HTMLInputElement> | React.FormEvent<HTMLSelectElement>
  ) => void;
  initialValue: string;
};

const PhoneField: React.FC<PhoneFieldProps> = ({
  initialValue,
  validateInput,
}) => {
  const [value, setValue] = useState(initialValue || "");
  const phone = useRifm({
    value,
    onChange: setValue,
    format: phoneFormat,
    mask: true,
    replace: addMask,
  });
  return (
    <input
      type="tel"
      required
      name="homePhone"
      pattern="^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$"
      placeholder="999-999-9999"
      value={phone.value}
      onChange={(e) => {
        validateInput(e);
        phone.onChange(e);
      }}
      onBlur={(e) => validateInput(e)}
      onFocus={(e) => validateInput(e)}
      sx={{
        width: "100%",
        outline: "none",
        border: "solid 1px #ccc",
        borderRadius: "4px",
        fontSize: "16px",
        padding: "10px",
      }}
    />
  );
};
export default PhoneField;
